<nav id="sidebar" class="sidebar" [ngClass]="{'sidebar-bg' : hasBackgroundImage()}">
    <div class="sidebar-content">
      <!-- <perfect- scrollbar> -->
        <div class="sidebar-menu">
          <ul>
            <li *ngFor="let menu of menus"
              [ngClass]="{'active': menu.active , 'sidebar-dropdown':menu.type === 'dropdown'}">
              <a *ngIf="menu.type !== 'header'" aria-label="Sidebar Titles" [routerLink]='menu.path' (click)='toggle(menu)'>
                   <span>{{menu.title}}</span>
              </a>

              <div *ngIf="menu.type === 'dropdown'" class="sidebar-submenu" [@slide]="getState(menu)">
                <ul>
                  <li *ngFor="let submenu of menu.submenus">
                    <a aria-label="Sidebar Subtitles" [routerLink]='submenu.path'> {{submenu.title}}
                    </a>
                    <ul *ngIf="submenu.type === 'dropdown'" class="sidebar-submenu" [@slide]="getState(menu)">
                      <li *ngFor="let subsubmenu of submenu.subsubmenus">
                        <a aria-label="Sidebar Subheadings" [routerLink]='subsubmenu.path'> {{subsubmenu.title}}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="contact">
          <h3>CONTACT US</h3>
          <div class="clearfix"></div>
          <div class="contact_details"><a aria-label="Email Us" tabindex=0 role=link (click)="openNewWindow('/unlocked/email-us')" >Email Us</a></div>
          <div class="contact_details"><a aria-label="Contact Support" tabindex=0 role=link (click)="openNewWindowContactUs('/unlocked/contact-us')">Contact Support</a></div>
          <div class="contact_details">or Call Us at</div>
          <div class="contact_details"><strong>800-234-DUNS</strong></div>
          <div class="contact_details"><strong>(3867)</strong></div>
          <div class="contact_details"><strong>Ext 7001</strong></div>
        </div>
      <!-- </perfect-scrollbar> -->
      </div>

  </nav>
